import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireManage } from '@/auth/require-manage'

export const Route = createFileRoute('/_layout/brevo/events/new')({
  beforeLoad: ({ context }) => {
    requireManage(context.me, 'brevo', redirect({ to: '/brevo/events', replace: true }))
  },
})
